import { render, staticRenderFns } from "./UpsertProductWrapper.vue?vue&type=template&id=7596f830&scoped=true&lang=pug&"
import script from "./UpsertProductWrapper.vue?vue&type=script&lang=js&"
export * from "./UpsertProductWrapper.vue?vue&type=script&lang=js&"
import style0 from "./UpsertProductWrapper.vue?vue&type=style&index=0&id=7596f830&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7596f830",
  null
  
)

export default component.exports